'use client'
import {Button, ButtonProps} from '@heroui/react'
import React from 'react'

import {cn} from '@/src/shared/utils/twMerge'

export interface AmyButtonProps extends ButtonProps {
  isInvalid?: boolean
}

const ButtonTypes = (variant: ButtonProps['variant']) => ({
  primary: cn(
    'text-white',
    variant === 'bordered' && 'border-primary text-primary'
  ),
  secondary: cn(
    'text-white',
    variant === 'bordered' && 'border-secondary text-secondary'
  ),
  danger: cn(
    'text-white fill-danger',
    variant === 'bordered' && 'border-danger text-danger fill-danger'
  ),
  success: cn(
    'text-white',
    variant === 'bordered' && 'border-success text-success'
  ),
  warning: cn(
    'text-white',
    variant === 'bordered' && 'border-warning text-warning'
  ),
  info: cn('text-white', variant === 'bordered' && 'border-info text-info'),
  light: cn('text-white', variant === 'bordered' && 'border-light text-light'),
  dark: cn('text-white', variant === 'bordered' && 'border-dark text-dark'),
})

const AmyButton = React.forwardRef<HTMLButtonElement, AmyButtonProps>(
  ({isInvalid, children, ...props}, ref) => {
    return (
      <Button
        ref={ref}
        size={props.size || 'md'}
        {...props}
        className={cn(
          'min-w-48 rounded-xl',
          props.className,
          ButtonTypes(props.variant)[props.color as keyof typeof ButtonTypes],
          isInvalid && ButtonTypes(props.variant).danger
        )}>
        {children}
      </Button>
    )
  }
)

AmyButton.displayName = 'AmyButton'

export default AmyButton
